import { useDispatch } from 'react-redux';
import moment from 'moment-timezone';

const useHeaderDateFilter = (params) => {
    const {
        event,
        selectedDate,
        setSelectedFacility,
        facilitiesAvailable,
        onChangeDate,
        guardUnpublishedChanges,
    } = params;

    const dispatch = useDispatch();
    const { eventSchedule } = event;
    const { timeZone, eventStartUtc, eventEndUtc } = eventSchedule;

    const calendarSelectedDate = moment.utc(selectedDate).tz(timeZone.value).startOf('day');
    const calendarStartDate = moment.utc(eventStartUtc).tz(timeZone.value).startOf('day');
    const calendarEndDate = moment.utc(eventEndUtc).tz(timeZone.value).startOf('day');

    const withUnPublishedChangesGuard = (action) => {
        if (guardUnpublishedChanges) {
            guardUnpublishedChanges(action);
        } else {
            action();
        }
    };

    const onFacilitySelected = (facilityId) => {
        withUnPublishedChangesGuard(() => {
            dispatch(setSelectedFacility(facilityId, facilitiesAvailable));
        });
    };

    const onDateChange = (date) => {
        withUnPublishedChangesGuard(() => {
            onChangeDate(date);
        });
    };

    const onGotoPreviousDayClick = () => {
        const previousDay = moment(selectedDate).tz(timeZone.value).subtract(1, 'days');
        withUnPublishedChangesGuard(() => {
            onChangeDate(previousDay);
        });
    };

    const onGotoNextDayClick = () => {
        const nextDay = moment(selectedDate).tz(timeZone.value).add(1, 'days');
        withUnPublishedChangesGuard(() => {
            onChangeDate(nextDay);
        });
    };

    return {
        onDateChange,
        onGotoPreviousDayClick,
        onGotoNextDayClick,
        onFacilitySelected,
        calendarSelectedDate,
        calendarStartDate,
        calendarEndDate,
    };
};

export default useHeaderDateFilter;
